import React from "react";
import { Paper, Grid, useMediaQuery } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Header from "./mainComponents/Header";
import InfoCard from "./mainComponents/InfoCard";
import { serviceData, testimonialData } from "../data";
import PlayerRepImg from "../static/images/PlayerRepImg";
import Sponsor from "../static/images/Sponsor";
import TeamRep from "../static/images/TeamRep";
import Testimonial from "./mainComponents/Testimonial";

const useStyle = makeStyles((theme) => ({
  pStyle: {
    width: "100%",
  },
  cardGrid: {
    display: "flex",
    justifyContent: "center",
  },
  containerGrid: {
    [theme.breakpoints.up("sm")]: {
      paddingTop: "10rem",
      paddingBottom: "10rem",
    },
  },
}));
const Bio = () => {
  const theme = useTheme();
  const classes = useStyle(theme);
  const cardImages = [<PlayerRepImg />, <TeamRep />, <Sponsor />];
  const renderCards = () => {
    return serviceData.map((item, index) => {
      return (
        <React.Fragment key={index}>
          <Grid className={classes.cardGrid} item lg={4} xs={12}>
            <InfoCard data={item} direction={"left"} timer={1500}>
              {cardImages[index]}
            </InfoCard>
          </Grid>
        </React.Fragment>
      );
    });
  };
  const testimonials = [
    testimonialData.map((item, index) => {
      return (
        <React.Fragment key={index}>
          <Testimonial data={item}>
            <img src={item.src} alt="no img"></img>
          </Testimonial>
        </React.Fragment>
      );
    }),
  ];
  return (
    <div>
      <Paper elevation="0" className={classes.pStyle}>
        <Header headerText={"Our Services"} />
        <div style={{ overflow: "hidden" }}>
          <Grid
            container
            spacing={10}
            justify="space-evenly"
            className={classes.containerGrid}
          >
            {renderCards()}
          </Grid>
        </div>
        <Header headerText={"Testimonial"} />
        {testimonials}
      </Paper>
    </div>
  );
};

export default Bio;
